var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns is-multiline d-flex flex-column flex-md-row" },
    [
      _c(
        "section",
        {
          staticClass: "sidebar column is-full-mobile is-4-tablet is-3-desktop"
        },
        [
          _c("cat-uxo-search-filters", { attrs: { query: _vm.query } }),
          _vm._v(" "),
          _c("cat-uxo-call-to-action", { staticClass: "mb-4 shape--top" }),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "btn w-100 mb-4", attrs: { href: "/contribute" } },
            [_vm._v("Contribute a New Hazard")]
          ),
          _vm._v(" "),
          _c("cat-uxo-stacked-ads")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "uxo-type column is-offset-1-desktop is-8 p-0" },
        [
          !_vm.fetchingHazards
            ? [
                _vm.hazardsCount > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "columns is-mobile align-items-center mb-2"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "columns is-multiline mb-3" },
                          [
                            _c("div", { staticClass: "column is-full mb-1" }, [
                              _c(
                                "h1",
                                {
                                  staticClass: "h2 font-weight-normal t-black"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.hazardsCount) + " Search Results"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "column is-9" },
                              [
                                _c("cat-uxo-search-box", {
                                  attrs: { query: _vm.query }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("cat-uxo-list", {
                  staticClass: "columns is-mobile is-multiline"
                })
              ]
            : [
                _c(
                  "div",
                  { staticClass: "content-loader" },
                  [
                    _c(
                      "ContentLoader",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          height: 56,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "460",
                            height: "56"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "56"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
          _vm._v(" "),
          _vm.pageCount
            ? _c("div", { staticClass: "columns mb-4 mb-lg-0" }, [
                _c(
                  "div",
                  { staticClass: "column is-6 py-0 mx-auto" },
                  [
                    _c("paginate", {
                      attrs: {
                        "page-count": _vm.pageCount,
                        "prev-text": "&nbsp;",
                        "next-text": "&nbsp;",
                        "prev-link-class": "pagination-previous",
                        "next-link-class": "pagination-next",
                        "container-class": "pagination-list",
                        "page-class": "pagination-item",
                        "page-link-class": "pagination-link",
                        "click-handler": _vm.paginate
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a2c7cbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a2c7cbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Search.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6a2c7cbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Search.vue
// module chunks = 0 1